import React from "react";
import DayAndHourSelector from "../DayAndHourSelector/DayAndHourSelector";
import SecondaryButton from "../SecondaryButton/SecondaryButton";
import MeetingTimes from "../../Data/MeetingTimes";
import InputErrorMessage from "../InputErrorMessage/InputErrorMessage";
import "./TimeSetter.css";

class TimeSetter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disableButton: true,
      timeslot: {
        weekdays: [],
        hours: [],
      },
      checkedDaysError: "",
      checkedHoursError: "",
      daysValue: "",
      fullDays: [],
      hoursValue: "",
      checkedDays: [],
      checkedHours: [],
      days: [
        {
          id: 0,
          value: "Weekdays",
          short: "Weekdays",
          isChecked: false,
        },
        {
          id: 1,
          value: "Mondays",
          short: "Mon",
          isChecked: false,
        },
        {
          id: 2,
          value: "Tuesdays",
          short: "Tue",
          isChecked: false,
        },
        {
          id: 3,
          value: "Wednesdays",
          short: "Wed",
          isChecked: false,
        },
        {
          id: 4,
          value: "Thursdays",
          short: "Thu",
          isChecked: false,
        },
        {
          id: 5,
          value: "Fridays",
          short: "Fri",
          isChecked: false,
        },
      ],
      hours: [
        {
          id: 0,
          value: "7am-8am",
          isChecked: false,
        },
        {
          id: 1,
          value: "11am-12pm",
          isChecked: false,
        },
        {
          id: 2,
          value: "12pm-1pm",
          isChecked: false,
        },
        {
          id: 3,
          value: "4pm-5pm",
          isChecked: false,
        },
        {
          id: 4,
          value: "5pm-6pm",
          isChecked: false,
        },
      ],
    };
    this.handleDayCheckboxClick = this.handleDayCheckboxClick.bind(this);
    this.handleDayCheckboxOnChange = this.handleDayCheckboxOnChange.bind(this);
    this.handleHourCheckboxClick = this.handleHourCheckboxClick.bind(this);
    this.handleHourCheckboxOnChange = this.handleHourCheckboxOnChange.bind(
      this
    );
    this.handleAddingTimeSlot = this.handleAddingTimeSlot.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.checkedDays !== prevState.checkedDays ||
      this.state.checkedHours !== prevState.checkedHours
    ) {
      if (
        this.state.checkedDays.length > 0 &&
        this.state.checkedHours.length > 0
      ) {
        this.setState({
          disableButton: false,
        });
      } else {
        this.setState({
          disableButton: true,
        });
      }
    }
  }

  /**
   * Method which handles checkbox click and adds values to fullDays
   * @param {String} value
   */
  handleDayCheckboxClick(value) {
    let fullDays = [];
    let valueArray = [];
    let stringValue = "";
    //Get all days based on state
    let days = [...this.state.days];
    //Get the day
    let day = days.find((d) => d.value === value);
    //If day exists
    //Clicked day is Weekdays
    if (day.value === "Weekdays") {
      if (day.isChecked === true) {
        //Empty selections
        this.setState({
          daysValue: "",
          checkedDays: [],
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            return {
              id: d.id,
              value: d.value,
              short: d.short,
              isChecked: false,
            };
          }),
        });
      } else {
        //Select all
        fullDays = days.map((d) => {
          return d.value;
        });
        this.setState({
          daysValue: "Weekdays",
          checkedDays: ["Weekdays"],
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            return {
              id: d.id,
              value: d.value,
              short: d.short,
              isChecked: true,
            };
          }),
        });
      }
      //Selected day is not 'Weekdays' but 'Weekdays is checked
    } else if (day.value !== "Weekdays" && days[0].isChecked === true) {
      //If day is currently checked and is going to get unchecked
      if (day.isChecked === true) {
        //Get all days except current day and weekdays
        days.forEach((d) => {
          if (d.value !== day.value && d.value !== "Weekdays") {
            fullDays.push(d.value);
          }
        });

        MeetingTimes.days.forEach((d) => {
          fullDays.forEach((v) => {
            if (d.value === v) {
              valueArray.push(d.short);
            }
          });
        });
        stringValue = valueArray.join(", ");

        this.setState({
          daysValue: stringValue,
          checkedDays: fullDays,
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            let result = fullDays.find((v) => v === d.value);
            if (result) {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: true,
              };
            } else {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: false,
              };
            }
          }),
        });
      }
      //If day is currently not checked and is going to get checked
      // else is useless as there is no option not checked if Weekdays is checked
    } else {
      //Now Weekdays is not active
      let selectedDays = [];
      days.forEach((d) => {
        if (d.isChecked === true && d.value !== "Weekdays") {
          selectedDays.push(d.value);
        }
      });

      //If day is currently checked and is going to be unchecked
      if (day.isChecked === true) {
        selectedDays.forEach((d) => {
          if (d !== day.value) {
            fullDays.push(d);
          }
        });

        MeetingTimes.days.forEach((d) => {
          let result = fullDays.find((v) => v === d.value);
          if (result) {
            valueArray.push(d.short);
          }
        });
        stringValue = valueArray.join(", ");

        this.setState({
          daysValue: stringValue,
          checkedDays: fullDays,
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            let result = fullDays.find((v) => v === d.value);
            if (result) {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: true,
              };
            } else {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: false,
              };
            }
          }),
        });
        //If day is currently not checked and is going to be checked
        //Careful if 4 days are checked
      } else {
        if (selectedDays.length === 4) {
          days.forEach((d) => {
            fullDays.push(d.value);
          });
          this.setState({
            daysValue: "Weekdays",
            checkedDays: ["Weekdays"],
            fullDays: fullDays,
            days: MeetingTimes.days.map((d) => {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: true,
              };
            }),
          });
        } else {
          selectedDays.push(day.value);
          MeetingTimes.days.forEach((d) => {
            let result = selectedDays.find((v) => v === d.value);
            if (result) {
              fullDays.push(d.value);
              valueArray.push(d.short);
            }
          });
          stringValue = valueArray.join(", ");
          this.setState({
            daysValue: stringValue,
            checkedDays: fullDays,
            fullDays: fullDays,
            days: MeetingTimes.days.map((d) => {
              let result = fullDays.find((v) => v === d.value);
              if (result) {
                return {
                  id: d.id,
                  value: d.value,
                  short: d.short,
                  isChecked: true,
                };
              } else {
                return {
                  id: d.id,
                  value: d.value,
                  short: d.short,
                  isChecked: false,
                };
              }
            }),
          });
        }
      }
    }
  }

  // handleDayCheckboxClick(value) {
  //     let days = this.state.days.map(d => {return d});
  //     if(value === 'Weekdays') {
  //         if(days[0].isChecked === true) {
  //             this.setState({
  //                 days: days.map(d => {
  //                     return {
  //                         id: d.id,
  //                         value: d.value,
  //                         short: d.short,
  //                         isChecked: false
  //                     }
  //                 })
  //             })
  //         } else {
  //             this.setState({
  //                 days: days.map(d => {
  //                     return {
  //                         id: d.id,
  //                         value: d.value,
  //                         short: d.short,
  //                         isChecked: true
  //                     }
  //                 })
  //             })
  //         }
  //     } else {
  //         this.setState(prevState => ({
  //             days: [
  //                 ...prevState.days.map(d => {
  //                     if(d.value === value) {
  //                         return {
  //                             id: d.id,
  //                             value: d.value,
  //                             short: d.short,
  //                             isChecked: !d.isChecked
  //                         }
  //                     } else {
  //                         return d
  //                     }
  //                 })
  //             ]
  //         }))
  //     }
  // }

  handleHourCheckboxClick(value) {
    let hours = [...this.state.hours];
    let checkedHours = [];
    let orderedCheckedHours = [];
    let valuesArray = [];
    let hoursValue = "";
    let hour = hours.find((v) => v.value === value);
    //Hour is checked => will get unchecked
    if (hour.isChecked === true) {
      hours.forEach((d) => {
        if (d.value !== value && d.isChecked === true) {
          checkedHours.push(d.value);
        }
      });

      MeetingTimes.hours.forEach((d) => {
        let result = checkedHours.find((v) => v === d.value);
        if (result) {
          orderedCheckedHours.push(d.value);
          valuesArray.push(d.value);
        }
      });

      hoursValue = valuesArray.join(", ");

      this.setState({
        hoursValue: hoursValue,
        checkedHours: orderedCheckedHours,
        hours: MeetingTimes.hours.map((d) => {
          let result = orderedCheckedHours.find((v) => v === d.value);
          if (result) {
            return {
              id: d.id,
              value: d.value,
              isChecked: true,
            };
          } else {
            return {
              id: d.id,
              value: d.value,
              isChecked: false,
            };
          }
        }),
      });

      //Hour is unchecked => will get checked
    } else {
      hours.forEach((d) => {
        if (d.value !== value && d.isChecked === true) {
          checkedHours.push(d.value);
        }
      });

      checkedHours.push(value);

      MeetingTimes.hours.forEach((d) => {
        let result = checkedHours.find((v) => v === d.value);
        if (result) {
          orderedCheckedHours.push(d.value);
          valuesArray.push(d.value);
        }
      });

      hoursValue = valuesArray.join(", ");

      this.setState({
        hoursValue: hoursValue,
        checkedHours: orderedCheckedHours,
        hours: MeetingTimes.hours.map((d) => {
          let result = orderedCheckedHours.find((v) => v === d.value);
          if (result) {
            return {
              id: d.id,
              value: d.value,
              isChecked: true,
            };
          } else {
            return {
              id: d.id,
              value: d.value,
              isChecked: false,
            };
          }
        }),
      });
    }
  }

  handleDayCheckboxOnChange(e) {
    let days = [...this.state.days];
    let checkedDays = [...this.state.checkedDays];
    if (days[0].isChecked === true) {
      this.setState((prevState) => ({
        timeslot: {
          hours: [...prevState.timeslot.hours],
          weekdays: ["Weekdays"],
        },
      }));
    } else if (checkedDays.length === 0) {
      this.setState((prevState) => ({
        timeslot: {
          hours: [...prevState.timeslot.hours],
          weekdays: [],
        },
      }));
    } else {
      this.setState((prevState) => ({
        timeslot: {
          hours: [...prevState.timeslot.hours],
          weekdays: [...checkedDays],
        },
      }));
    }
  }

  handleHourCheckboxOnChange(e) {
    this.setState((prevState) => ({
      timeslot: {
        weekdays: [...prevState.timeslot.weekdays],
        hours: [...this.state.checkedHours],
      },
    }));
  }

  // handleHourCheckboxOnChange(e) {
  //     let hours = this.state.hours;
  //     let values = [];
  //     let value = '';
  //     let checked = this.state.checkedHours;
  //     if(!e.target.checked) {
  //         checked.push(e.target.value);
  //             MeetingTimes.hours.forEach(d => {
  //                 checked.forEach(v => {
  //                     if(v === d.value) {
  //                         values.push(d.value)
  //                     }
  //                 })
  //             });
  //             value=values.join(', ');
  //             this.setState({
  //                 hoursValue: value,
  //                 checkedHours: checked
  //             })
  //     } else {
  //             let newChecked = []
  //             hours.forEach(d => {
  //                 if(d.isChecked && d.value !== e.target.value) {
  //                     newChecked.push(d.value);
  //                     values.push(d.value)
  //                 }
  //             })
  //             value=values.join(', ');
  //             this.setState({
  //                 hoursValue: value,
  //                 checkedHours: newChecked
  //             })
  //     }
  // }

  handleAddingTimeSlot(e) {
    e.preventDefault();
    if (this.state.checkedDays.length === 0) {
      this.setState({
        checkedDaysError: "Please select days from the input below...",
      });
    } else {
      this.setState({
        checkedDaysError: "",
      });
      if (this.state.checkedHours.length === 0) {
        this.setState({
          checkedHoursError: "Please select times from the input below...",
        });
      } else {
        this.setState({
          checkedHoursError: "",
          checkedDays: [],
          days: MeetingTimes.days.map((d) => {
            return {
              id: d.id,
              value: d.value,
              short: d.short,
              isChecked: false,
            };
          }),
          daysValue: "",
          fullDays: [],
          checkedHours: [],
          hours: MeetingTimes.hours.map((d) => {
            return {
              id: d.id,
              value: d.value,
              isChecked: false,
            };
          }),
          hoursValue: "",
        });

        let newTimeSlot = {
          weekdays: [...this.state.checkedDays],
          hours: [...this.state.checkedHours],
        };
        this.props.handleAddingTimeSlot(newTimeSlot);
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div>
          {this.state.checkedDaysError === "" ? null : (
            <InputErrorMessage errorText={this.state.checkedDaysError} />
          )}
          {this.state.checkedHoursError === "" ? null : (
            <InputErrorMessage errorText={this.state.checkedHoursError} />
          )}
        </div>
        <div className="time-setter" style={{ zIndex: 4 }}>
          <DayAndHourSelector
            daySelectorName="time-setter-selector-day"
            daysValue={this.state.daysValue}
            handleDayCheckboxClick={this.handleDayCheckboxClick}
            days={this.state.days}
            handleDayCheckboxOnChange={this.handleDayCheckboxOnChange}
            hourSelectorName="time-setter-selector-hour"
            hoursValue={this.state.hoursValue}
            handleHourCheckboxClick={this.handleHourCheckboxClick}
            hours={this.state.hours}
            handleHourCheckboxOnChange={this.handleHourCheckboxOnChange}
            zIndexValue={4}
          />

          <div className="time-setter-button">
            <SecondaryButton
              onClickFunction={(e) => this.handleAddingTimeSlot(e)}
              isDisabled={this.state.disableButton}
              buttonText="+ Add time slot"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TimeSetter;
